import axios from "axios";
import config from "../Utility/ConfigUtility";
import { alert } from "../Components/Shared/AlertUtility";
import "../Components/Shared/TokenInterceptor";

const CommonEndpoints = {
    SendEmailToGeneral : (assetId, payload) => axios.post(`${config.apiUrl}/email/sendtoasset/${assetId}`, payload),
    SendEmailToIT : (payload) => axios.post(`${config.apiUrl}/email/sendtoitsupport`, payload),
    alert
};

export default CommonEndpoints;